import React, { useState, useEffect } from 'react';
import { Audio } from 'expo-av';
import { View, Text, TouchableOpacity } from 'react-native';
import { oStyles } from './olonkho-styles';
import { Ionicons } from '@expo/vector-icons';

export default function AudioPlayer({ title, source, isEnabled, onClose, onEnd }) {
    const [currentTitle, setTitle] = useState("");
    const [audio, setAudio] = useState();
    const [isVisible, setVisible] = useState(true);
    const [isPaused, setPaused] = useState(true);
    
    async function getSoundAsync() {
        const { sound } = await Audio.Sound.createAsync(source);
        return sound;
    }

    async function loadFromSourceAsync() {
        if (source) {
            setTitle(title);
            if (audio) {
                await audio.unloadAsync();
            }
            await getSoundAsync().then((sound) => {
                setAudio(sound);
            }).catch((t, error) => console.log(error));
        }
    }

    async function close() {
        if (isVisible) {
            if (audio) {
                await audio.unloadAsync();
            }
            if (onClose) {
                onClose();
            }
            setVisible(false);
        }
    }

    function playPause() {
        if (isVisible) {
            setPaused(!isPaused);
        }
    }

    async function play() {
        if (isVisible) {
            if (audio) {
                audio.setOnPlaybackStatusUpdate(async (status) => {
                    if (status.didJustFinish === true) {
                        if (onEnd) {
                            onEnd();
                        }
                    }
                });
                await Audio.setAudioModeAsync({
                    staysActiveInBackground: true
                });
                await audio.playAsync();
            }
        }
    }

    async function pause() {
        if (isVisible) {
            if (audio) {
                await audio.pauseAsync();
            }
        }
    }

    useEffect(async () => {
        if (isEnabled) {
            setVisible(isEnabled);
            await loadFromSourceAsync();
            setPaused(false);
        }
        else {
            close();
        }
    }, [isEnabled]);

    useEffect(async () => {
        if (isVisible) {
            if (isPaused) {
                await pause();
            }
            else {
                await play();
            }
        }
    }, [isPaused]);

    useEffect(() => {
        return audio
        ? () => {
            audio.unloadAsync(); }
        : undefined;
    }, [audio]);

    useEffect(async () => {
        if (isVisible) {
            if (!isPaused) {
                await play();
            }
        }
    }, [audio]);

    useEffect(async () => {
        if (isVisible) {
            if(source) {
                loadFromSourceAsync();
            }
            else {
                close();
            }
        }
    }, [source]);

    if (isVisible) {
        return (
            <View style={ oStyles.player_container }>
                <Text style={ oStyles.player_title }>{ currentTitle }</Text>
                <TouchableOpacity onPress={ () => playPause() }>
                    <Ionicons name={ isPaused ? "play-circle-outline" : "pause-circle-outline" } size={48} color="white"/>
                </TouchableOpacity>
                <TouchableOpacity>
                    <Ionicons name="stop-circle-outline" size={48} color="white" onPress={ () => { close(); } }/>
                </TouchableOpacity>
            </View>
        );
    }
    else {
        return null;
    }
}